import { Injectable } from '@angular/core';
import { TranscriptionService } from '../../core/services/transcription.service';
import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects';

import { catchError, map, of, switchMap, tap } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { APPLICATION_REDUCER } from '../reducers/application.reducer';
import { Store } from '@ngrx/store';
import {
  ACE_TRANSCRIPTION_API_ACTIONS,
  AUDIO_API_ACTIONS,
  STANDARD_TRANSCRIPTION_API_ACTIONS,
  APPLICATION_ACTIONS,
} from '../actions';

@Injectable()
export class TranscriptionEffects {
  constructor(
    private readonly transcriptionService: TranscriptionService,
    private readonly actions$: Actions,
    private readonly store: Store,
  ) {}

  getStandardTranscription$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(STANDARD_TRANSCRIPTION_API_ACTIONS.get),
      tap(() => APPLICATION_ACTIONS.showLoader()),
      concatLatestFrom(() => this.store.select(APPLICATION_REDUCER.selectDataQueryParam)),
      switchMap(([, { queryName, value }]) =>
        this.transcriptionService.getStandardTranscription(queryName, value).pipe(
          map((data) => STANDARD_TRANSCRIPTION_API_ACTIONS.success({ data })),
          catchError((error: HttpErrorResponse) => of(STANDARD_TRANSCRIPTION_API_ACTIONS.error({ error }))),
        ),
      ),
    );
  });

  getAceTranscription$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ACE_TRANSCRIPTION_API_ACTIONS.get),
      concatLatestFrom(() => this.store.select(APPLICATION_REDUCER.selectDataQueryParam)),
      switchMap(([, { queryName, value }]) =>
        this.transcriptionService.getAceTranscription(queryName, value).pipe(
          map((data) => ACE_TRANSCRIPTION_API_ACTIONS.success({ data })),
          catchError((error: HttpErrorResponse) => of(ACE_TRANSCRIPTION_API_ACTIONS.error({ error }))),
        ),
      ),
    );
  });

  getAudioRecording$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AUDIO_API_ACTIONS.get),
      concatLatestFrom(() => this.store.select(APPLICATION_REDUCER.selectDataQueryParam)),
      switchMap(([, { queryName, value }]) =>
        this.transcriptionService.getAudioRecording(queryName, value).pipe(
          map((data) => AUDIO_API_ACTIONS.success({ data })),
          catchError((error: HttpErrorResponse) => of(AUDIO_API_ACTIONS.error({ error }))),
        ),
      ),
    );
  });
}
